import { List } from "@mui/material";

import { useMe } from "../api";
import { ShiftDayListItem } from "./ShiftDayListItem";

const ShiftDayList = ({
  shiftGroup = [],
  setIsOpen,
  weekday,
  dayOfMonth,
  month,
  selectedScheduleType,
  date
}) => {
  const { data: me } = useMe();

  shiftGroup
    .filter(({ shifts }) =>
      shifts.some(({ isAutoassignable }) => isAutoassignable),
    )
    .map((group) =>
      Object.assign({}, group, {
        shifts: group.shifts.filter(({ isAutoassignable }) => isAutoassignable),
      }),
    )
    .sort((thisGroup, thatGroup) => {
      if (thisGroup.distance !== null && thatGroup.distance === null) {
        return -1;
      }

      if (thisGroup.distance === null && thatGroup.distance !== null) {
        return 1;
      }

      if (thisGroup.distance < thatGroup.distance) {
        return -1;
      }

      if (thisGroup.distance > thatGroup.distance) {
        return 1;
      }

      if (thisGroup.contractLocationName < thatGroup.contractLocationName) {
        return -1;
      }

      if (thisGroup.contractLocationName > thatGroup.contractLocationName) {
        return 1;
      }

      if (me.jobTitle) {
        if (
          me.jobTitle !== thisGroup.jobTile &&
          me.jobTitle === thatGroup.jobTile
        ) {
          return -1;
        }

        if (
          me.jobTitle === thisGroup.jobTile &&
          me.jobTitle !== thatGroup.jobTile
        ) {
          return 1;
        }
      }

      if (thisGroup.jobTitle < thatGroup.jobTitle) {
        return -1;
      }

      if (thisGroup.jobTitle > thatGroup.jobTitle) {
        return 1;
      }

      if (thisGroup.startTime < thatGroup.startTime) {
        return -1;
      }

      if (thisGroup.startTime > thatGroup.startTime) {
        return 1;
      }

      if (thisGroup.endTime < thatGroup.endTime) {
        return -1;
      }

      if (thisGroup.endTime > thatGroup.endTime) {
        return 1;
      }

      return 0;
    });

  return (
    <List sx={{ padding: "0px" }} dense>
      {shiftGroup.map((shiftGroup) => (
        <ShiftDayListItem
          key={shiftGroup.groupKey}
          shiftGroup={shiftGroup}
          setIsOpen={setIsOpen}
          weekday={weekday}
          dayOfMonth={dayOfMonth}
          month={month}
          selectedScheduleType={selectedScheduleType}
          date={date} 
        />
      ))}
    </List>
  );
};

export { ShiftDayList };
